import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getReportsStatus } from '../../canopy-ui-components/api/generateReports';
import { getGeneratedReports } from '../../canopy-ui-components/helpers/localStorage';
interface Reports {
    isLoading: boolean;
    generatedReports: any;
}

const initialState: Reports = {
    isLoading: false,
    generatedReports:
        getGeneratedReports()?.sort(
            ({ createdAt: a }: any, { createdAt: b }: any) => {
                return b.valueOf() - a.valueOf();
            }
        ) || [],
};

export const fetchReportsStatus = createAsyncThunk(
    'reports/status',
    getReportsStatus
);

const reportsSlice = createSlice({
    name: 'reports',
    initialState: initialState,
    reducers: {
        resetGeneratedReports(state: Reports) {
            state.generatedReports = [];
        },
    },

    extraReducers: (builder) => {
        builder.addCase(
            fetchReportsStatus.fulfilled,
            (state, action: PayloadAction<any>) => {
                updateGeneratedReports(state, action, false);
            }
        );

        builder.addCase(fetchReportsStatus.rejected, (state, action) => {
            updateGeneratedReports(state, action, false);
        });
        builder.addCase(fetchReportsStatus.pending, (state, action) => {
            updateGeneratedReports(state, action, true);
        });
    },
});

const updateGeneratedReports = (
    state: Reports,
    action: PayloadAction<any>,
    isLoading: boolean
) => {
    if (action.payload?.sessionId) {
        const currentReport = state.generatedReports?.findIndex(
            ({ sessionId }: any) => sessionId === action.payload?.sessionId
        );
        const report = { ...action.payload, isLoading };
        if (currentReport !== -1) {
            state.generatedReports[currentReport] = report;
        } else {
            state.generatedReports.push(report);
        }
    }
};
export const { resetGeneratedReports } = reportsSlice.actions;
export default reportsSlice;
